import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class OppositionsContainer extends ShadowDOMElement {
	static className = "OppositionsContainer";
	
	static properties = {
		text: {type : String, attribute: 'text'},
		textFree: {type : String, attribute: 'text-free'}
	};

	constructor() {
		super();
		this.text = 'Les oppositions, s\'il y a lieu, seront reçues dans les dix jours de la dernière en date des publications légales, au fonds vendu.';
		this.textFree = 'Les oppositions, s\'il y a lieu, seront reçues dans les dix jours de la dernière en date des publications légales, pour la validité au --- et pour la correspondance au ---';
	}

	render() {
    return html`
      <div>
        <row-wrapper>
          <select-field label="Oppositions *" required value="0" @change="${this.handleSelectChange}" name="id_opposition_type">
            <option-component label="Oppositions" value="0"></option-component>
            <option-component label="Au fond vendu" value="1"></option-component>
            <option-component label="Texte libre" value="2"></option-component>
          </select-field>
        </row-wrapper>
		
        <div-container id="oppositions-container" visible="false">
          <row-with-tooltip tooltip-text="Reprendre les termes de l'acte de cession.">
            <text-area-field value="${this.text}" name="terms"></text-area-field>
          </row-with-tooltip>
        </div-container>
		
		<div-container id="oppositions-container-free" visible="false">
		  <row-with-tooltip tooltip-text="Reprendre les termes de l'acte de cession.">
		    <text-area-field value="${this.textFree}" name="terms_free"></text-area-field>
		  </row-with-tooltip>
		</div-container>
      </div>
    `;
	}

	handleSelectChange (event){
		const selectedValue = event.target.value;
		const oppositionsContainer = this.shadowRoot.querySelector('#oppositions-container');
		const oppositionsContainerFree = this.shadowRoot.querySelector('#oppositions-container-free');

		oppositionsContainer.visible = selectedValue === '1';
		oppositionsContainerFree.visible = selectedValue === '2';
	}
}

customElements.define('oppositions-container', OppositionsContainer);
